/**
 * Kullanici Sozlesmesi Sayfasi
 * KONSULTAN OZEL SAGLIK HIZMETLERI GIDA HAYV. TURZ. SAN. VE TIC. LTD. STI.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft, Baby, FileText } from 'lucide-react';

const COMPANY_NAME = "KONSULTAN OZEL SAGLIK HIZMETLERI GIDA HAYV. TURZ. SAN. VE TIC. LTD. STI.";

const UserAgreementPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <header className="bg-white/80 backdrop-blur border-b sticky top-0 z-10">
        <div className="container mx-auto px-4 py-3 flex items-center gap-4">
          <Button data-testid="back-button" variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-4 h-4 mr-1" />
            Geri
          </Button>
          <div className="flex items-center gap-2">
            <Baby className="w-6 h-6 text-pink-500" />
            <span className="font-bold text-slate-800">BabyFace AI</span>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white rounded-2xl shadow-sm border p-6 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <FileText className="w-8 h-8 text-pink-500" />
            <h1 data-testid="agreement-title" className="text-2xl md:text-3xl font-bold text-slate-800">
              Kullanici Sozlesmesi
            </h1>
          </div>

          <p className="text-sm text-slate-400 mb-6">Son guncelleme: 25 Mart 2026</p>

          <div className="prose prose-slate max-w-none text-sm leading-relaxed space-y-6">
            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">1. Taraflar</h2>
              <p className="text-slate-600">
                Bu sozlesme, <strong>{COMPANY_NAME}</strong> (bundan sonra "Sirket" olarak anilacaktir) ile 
                BabyFace AI platformuna kayit olan kullanici (bundan sonra "Kullanici" olarak anilacaktir) arasinda 
                akdedilmistir.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">2. Hizmetin Tanimi</h2>
              <p className="text-slate-600">
                BabyFace AI, yapay zeka teknolojisi kullanarak ultrason goruntulerinden bebek yuzu gorsellestirmesi 
                sunan bir dijital platformdur. Platform; 4K ultrason iyilestirme, 3D modelleme, genetik fuzyon ve 
                4D simulasyon hizmetlerini icerir.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">3. Hizmet Kullanim Kosullari</h2>
              <ul className="list-disc pl-5 text-slate-600 space-y-1">
                <li>Platform yalnizca 18 yas ve uzerindeki bireyler tarafindan kullanilabilir.</li>
                <li>Kullanici, platformu yalnizca kisisel ve ticari olmayan amaclarla kullanmayi kabul eder.</li>
                <li>Yuklenen ultrason goruntuleri gercek tibbi goruntuler olmalidir.</li>
                <li>Platform tarafindan uretilen goruntuler tahmini gorsellestirmelerdir ve tibbi teshis amaci tasimazlar.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">4. Kredi Sistemi ve Odeme</h2>
              <ul className="list-disc pl-5 text-slate-600 space-y-1">
                <li>Hizmetler kredi sistemi ile sunulmaktadir. Her uretim isleminde 1 kredi harcanir.</li>
                <li>Satin alinan krediler iade edilemez. Ancak teknik bir hata nedeniyle uretim basarisiz olursa kredi iade edilir.</li>
                <li>Fiyatlar Turk Lirasi (TL) cinsindendir ve KDV dahildir.</li>
                <li>Sirket, fiyatlari onceden bildirim yaparak degistirme hakkini sakli tutar.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">5. Fikri Mulkiyet Haklari</h2>
              <p className="text-slate-600">
                Platform uzerindeki tum yazilim, tasarim, algoritma ve icerikler {COMPANY_NAME}'ye aittir. 
                Kullanici, platformu kullanarak urettigi gorseller uzerinde kisisel kullanim hakkina sahiptir ancak 
                bu gorselleri ticari amacla kullanamaZ, cogaltamaz veya dagitamaz.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">6. Gizlilik ve Veri Koruma</h2>
              <p className="text-slate-600">
                Kullaniciya ait kisisel veriler, 6698 sayili Kisisel Verilerin Korunmasi Kanunu (KVKK) kapsaminda 
                islenir. Detayli bilgi icin Gizlilik Politikasi sayfamizi inceleyiniz. Yuklenen ultrason goruntuleri 
                sifrelenerek saklanir ve ucuncu taraflarla paylasilmaz.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">7. Sorumluluk Sinirlamasi</h2>
              <ul className="list-disc pl-5 text-slate-600 space-y-1">
                <li>Uretilen gorseller yapay zeka tahminidir ve bebegin gercek gorunumunu garanti etmez.</li>
                <li>Platform tibbi cihaz veya teshis araci degildir.</li>
                <li>Sirket, yapay zeka tarafindan uretilen gorsellerin dogrulugundan sorumlu tutulamaz.</li>
                <li>Teknik arizalar nedeniyle olusabilecek hizmet kesintilerinden dolayi sorumluluk kabul edilmez.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">8. Cayma Hakki</h2>
              <p className="text-slate-600">
                Dijital icerik niteligindeki hizmetimizde, kredi kullanimi ile uretim baslatiliktan sonra 
                6502 sayili Tuketicinin Korunmasi Hakkinda Kanun'un 53. maddesi uyarinca cayma hakki kullanilamaz. 
                Henuz kullanilmamis krediler icin satin alma tarihinden itibaren 14 gun icinde cayma hakki 
                kullanilabilir.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">9. Sozlesme Degisiklikleri</h2>
              <p className="text-slate-600">
                Sirket, bu sozlesmeyi oNceden bildirim yaparak guncelleme hakkini sakli tutar. 
                Guncellemeler platformda yayinlandigi tarihte yururluge girer. Kullanicinin platformu kullanmaya 
                devam etmesi, guncel sozlesmeyi kabul ettigi anlamina gelir.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">10. Uyusmazlik Cozumu</h2>
              <p className="text-slate-600">
                Bu sozlesmeden dogan uyusmazliklarda Istanbul Mahkemeleri ve Icra Daireleri yetkilidir. 
                Turk hukuku uygulanir.
              </p>
            </section>

            <section className="bg-slate-50 rounded-lg p-4 mt-8">
              <h2 className="text-lg font-semibold text-slate-800 mb-2">Sirket Bilgileri</h2>
              <p className="text-slate-600">
                <strong>Unvan:</strong> {COMPANY_NAME}<br />
                <strong>Web:</strong> babyface.ai<br />
                <strong>E-posta:</strong> info@babyface.ai
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserAgreementPage;
